import styled, { css } from 'styled-components';

export default {
  Table: styled.table`
    width: 100%;
    border-spacing: 0 2px;

    td {
      padding: 12px 0;

      &:first-child {
        padding-left: 16px;
      }

      &:last-child {
        padding-right: 16px;
      }

      @media screen and (min-width: 720px) {
        &:first-child {
          padding-left: 48px;
        }

        &:last-child {
          padding-right: 48px;
          width: 20%;
          box-sizing: border-box;
          min-width: 335px;
        }
      }

      ${(props) =>
        props.theme.isRtl &&
        css`
          &:first-child {
            padding-left: 0;
            padding-right: 16px;
          }

          &:last-child {
            padding-right: 0;
            padding-left: 16px;
          }

          @media screen and (min-width: 720px) {
            &:first-child {
              padding-left: 0;
              padding-right: 48px;
            }

            &:last-child {
              padding-right: 0;
              padding-left: 048px;
            }
          }
        `}
    }

    tr {
      background-color: #fff;
    }
  `,
};
